import { JiraServiceManagementConnectionForm } from "~/areas/configuration/components/Settings/AddJiraServiceManagementConnectionWorkflow";
import type { JiraServiceManagementIntegrationConnection } from "~/areas/configuration/components/Settings/JiraServiceManagementIntegrationSettingsPage";
import type { EditJiraServiceManagementConnectionWorkflowInput } from "~/workflows/JiraServiceManagementConnectionWorkflowInput";
export interface EditJiraServiceManagementConnectionWorkflowProps {
    workflowInput: EditJiraServiceManagementConnectionWorkflowInput;
    completeWorkflow: (output: JiraServiceManagementIntegrationConnection) => void;
}
export function EditJiraServiceManagementConnectionWorkflow({ completeWorkflow, workflowInput }: EditJiraServiceManagementConnectionWorkflowProps) {
    return <JiraServiceManagementConnectionForm workflowInput={workflowInput} completeWorkflow={completeWorkflow}/>;
}
